@if (anchors.length > 0) {
    <dx-scroll-view [scrollByContent]="true"
                    direction="vertical"
                    class="scroll-view">
        <dx-sortable data-test="anchors-list"
                     [data]="anchors"
                     [ngClass]="{ 'dragging-anchor': isDraggingAnchor }"
                     itemOrientation="vertical"
                     handle="#anchorGripper"
                     [allowReordering]="true"
                     [dragDirection]="'vertical'"
                     dropFeedbackMode="push"
                     [allowDropInsideItem]="false"
                     (onDragStart)="onAnchorDragStart($event)"
                     (onReorder)="reorderAnchors($event)">
            @for (anchor of anchors; track anchor) {
                <adapt-strategic-anchor class="avoid-page-break-inside"
                                        [anchor]="anchor"
                                        [isEditing]="isEditing"
                                        [isCollapsible]="!isEditing"
                                        [collapsed]="collapsed"> </adapt-strategic-anchor>
            }
        </dx-sortable>
    </dx-scroll-view>
} @else {
    No strategic anchors have been defined.
}
